import React from 'react';
import { SelectHierarchyLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import LoadingCard from '../../../../../../components/loadingCard';

export function pruneEmptyGroups(items) {
    // Helper function to recursively remove empty groups
    return items.filter(item => {
        if (!item.children) return true;
        // Recursively prune empty children
        item.children = pruneEmptyGroups(item.children);
        // Keep this group if it has any children
        return item.children.length > 0;
    });
}

const Selector = ({ key = 0, onSelect, onOpen = () => {}, form, tree, indexes, label, loading, multiple = true, isInvitations = false }) => {
    const { t } = useTranslation();
    const defaultLabel = t('attendees.printStock.selectRate.selectLabel');

    const options = pruneEmptyGroups(
        tree.toOptions({
            filter: rate =>
                (rate.distributor === null || rate.distributor === undefined) &&
                Object.keys(indexes)
                    .map(rate_id => parseInt(rate_id))
                    .includes(rate.pk),
            filterGroup: gr => gr.removed === null && (gr.children.length || gr.rates.length)
        })
    ).filter(entry => (entry.children ? entry.children.length : entry));

    const handleChange = React.useCallback(
        selected => {
            const normalizedSelected = Array.isArray(selected) ? selected : [selected];
            const rates = normalizedSelected.filter(id => indexes[id]).map(id => indexes[id]);
            onSelect(rates);
        },
        [onSelect, indexes]
    );

    const handleLabelChange = React.useCallback(selected => {
        return selected.length
            ? `${selected.length} ${
                  selected.length > 1
                      ? `${t('ticket.common.rates')} ${t('attendees.addAttendees.selectHierarchy.selectedPlural')} `
                      : `${t('ticket.common.rate')} ${t('attendees.addAttendees.selectHierarchy.selectedSingular')} `
              }`
            : '';
    }, []);

    const totalRates = React.useMemo(() => {
        let count = 0;
        options.forEach(gr => {
            if (gr.children?.length) {
                gr.children.forEach(r => {
                    count += 1;
                });
            } else {
                count = options.length;
            }
        });
        return count;
    }, [options]);

    if (loading) {
        return <LoadingCard loading />;
    }

    return (
        <SelectHierarchyLabel
            key={key}
            onOpen={onOpen}
            label={label || defaultLabel}
            placeholder={t('ticket.common.action.select')}
            placeholderSearch={t('ticket.common.action.search')}
            depth={0}
            height="maxi"
            labelSelectAll={t('attendees.addAttendees.selectHierarchy.label')}
            selected={form.selected_rates?.map(r => r.rateId)}
            onChange={handleChange}
            {...(!isInvitations && { onLabelSelected: handleLabelChange })}
            {...(isInvitations && { widthIndent: '10px' })}
            options={options}
            totalItems={totalRates}
            labelApply={t('ticket.common.action.select')}
            multi={isInvitations ? false : multiple}
            chevron={true}
            {...(isInvitations && { value: form.selected_rates[0]?.rateId })}
        />
    );
};

export default Selector;
